module.exports = __webpack_public_path__ + "media/images/plans/arrow-top-c3948562fff791c771eeaf80d5995907.svg";